import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";

import type { ExchangeBetslipCapabilities, SportsbookBetslipCapabilities } from "../../../contract";
import {
  BETSLIP__EXC_CAPABILITIES_RECEIVED,
  BETSLIP__SBK_CAPABILITIES_RECEIVED,
  type ExchangeCapabilitiesReceivedAction,
  type SportsbookCapabilitiesReceivedAction,
} from "./capabilities-actions";

// Layout, not passive: these run before paint, so no painted frame exists in which a component has
// capabilities and the slice does not. Safe because nothing in this repo server-renders the tree.
export function useSportsbookCapabilitiesSync(capabilities: SportsbookBetslipCapabilities): void {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch<SportsbookCapabilitiesReceivedAction>({
      type: BETSLIP__SBK_CAPABILITIES_RECEIVED,
      payload: capabilities,
    });
  }, [dispatch, capabilities]);
}

export function useExchangeCapabilitiesSync(capabilities: ExchangeBetslipCapabilities): void {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch<ExchangeCapabilitiesReceivedAction>({
      type: BETSLIP__EXC_CAPABILITIES_RECEIVED,
      payload: capabilities,
    });
  }, [dispatch, capabilities]);
}
